import { ObservableFromFetch } from "../ObservableFromFetch"
import LabAccount from "./Model/LabAccount"

export default function ActivateAndInActiveLabAccountObservable(activeLabAccounts: LabAccount[], inactiveLabAccounts: LabAccount[]) {
  const requestBody = JSON.stringify({ ActiveLabAccount: activeLabAccounts, InActiveLabAccount: inactiveLabAccounts })

  return ObservableFromFetch<string>("FFOrderLaboratory/ActivateAndInActiveLabAccount", requestBody)
}